import classNames from "classnames";
import React from "react";

import { hotjarAttr, IHotjarProps } from "@/browser";

import {
  groupBaseClass,
  groupFlexClass,
  groupInnerClass,
  IStyleGroupBase,
  IStyleGroupFlex,
  IStyleGroupInner,
} from "../Style";

interface IRow extends IStyleGroupBase, IStyleGroupFlex, IStyleGroupInner, IHotjarProps {
  className?: string;
}

/**
 * @deprecated Use iris-based implementation instead.
 */
class Row extends React.PureComponent<IRow, {}> {
  static defaultProps = {
    size: "md",
  };

  render() {
    const rootName = "el-grid-row";
    const gridRoot = "-grid";
    const classes = classNames(
      rootName,
      gridRoot,
      groupFlexClass(this.props),
      groupBaseClass(this.props),
      groupInnerClass(this.props),
      this.props.className,
    );

    return (
      <div className={classes} {...hotjarAttr(this.props)}>
        {this.props.children}
      </div>
    );
  }
}

export default Row;
